<div class="container">
  <img
    class="logo-gm"
    src="https://s3.eu-west-3.amazonaws.com/students-platform.dev.gamelearn.io/assets/img/logo.png"
    alt=""
  />
  <h3 class="h3">{{ 'auth.notAvailableForPhone' | translate }}</h3>
</div>
